module.exports = "<link-collection> <a href=#! class=active>Vue</a> <a href=#!>React</a> <a href=#!>Angular</a> </link-collection>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/collections/link-collection-with-slot.vue
 ** module id = 243
 ** module chunks = 0
 **/